/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import LinearProgress from "@mui/material/LinearProgress";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
const containerStyle = {
  width: "100%",
  height: "100%",
};

interface MapProps {
  searchQrCode: string | null;
}

const GoogleMapApi: React.FC<MapProps> = ({ searchQrCode }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);

  const [selectedMarker, setSelectedMarker] = useState<number | null>(null);
  const [center, setCenter] = useState< { lat: number; lng: number } | undefined>(undefined);

  const calculateCenter = () => {
    if (!data || data.length === 0) {
      console.error("No data available");
      return { lat: 28.6139, lng: 77.2090 }; // Default to Delhi
    }
  
    const mid = Math.floor(data.length / 2);
    const centerMarker = data[mid];
  
    return {
      lat: centerMarker?.latitude ? parseFloat(centerMarker.latitude) : 28.6139,
      lng: centerMarker?.longitude ? parseFloat(centerMarker.longitude) : 77.2090,
    };
  };
  
 
  useEffect(() => {
    ZyppLiteApi.api.getAllFleetLocation( searchQrCode)
    .then((e) => {
      setData(e.data.vehicles);
      setLoading(false);
    })

    
  }, [searchQrCode]);

  
  
  useEffect(() => {
    if (data.length > 0) {
      setCenter(calculateCenter());
    }
  }, [data]);
  
  const handleMarkerClick = (index: number) => {
    setSelectedMarker(index);
  };
  
  return (
    <>
     {loading ? (
        <div className="w-full">
          <LinearProgress
            sx={{
              backgroundColor: "white",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#00CD5B",
              },
            }}
          />
        </div>
      ) : (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          options={{ fullscreenControl: true, zoomControl: true }}
          zoom={10}
        >
          <MarkerClusterer averageCenter enableRetinaIcons gridSize={5}>
            {(clusterer) => (
              <>
                {data.map((item, index) => (
                  <Marker
                    key={index}
                    position={{
                      lat: parseFloat(item.latitude),
                      lng: parseFloat(item.longitude),
                    }}
                    icon={{
                      url: "https://zypp.app/clientdashboard-mailer/running.svg",
                    }}
                    onClick={() => handleMarkerClick(index)}
                    clusterer={clusterer}
                  />
                ))}
              </>
            )}
          </MarkerClusterer>
          <div>
            {selectedMarker !== null && (
              <>
                <InfoWindow
                  position={{
                    lat: parseFloat(data[selectedMarker].latitude),
                    lng: parseFloat(data[selectedMarker].longitude),
                  }}
                  onCloseClick={() => setSelectedMarker(null)}
                >
                  <div className="">
                   
                   
                      <p className="text-left text-slate-700 flex items-center">
                      <span className="mr-1 font-bold text-left text-4xl">•</span>
                        <b>{data[selectedMarker].vehicleNo}</b>
                      </p>
                      <p className="mr-2 font-bold text-left mt-2">User Id</p>
                      <p className="text-left text-slate-700 flex items-center ">
                        {data[selectedMarker].userId}
                      </p>
                      <p className="mr-2 font-bold text-left mt-2">Speed</p>
                      <p className="text-left text-slate-700 flex items-center ">
                        {data[selectedMarker].speed}
                      </p>
                    
                      {/* <p className="font-medium text-left text-slate-700 flex items-center mt-2">
                        <span className="mr-2">Name </span>
                        {data[selectedMarker].rider_name}
                      </p>
                      <p className="font-medium text-left text-slate-700 flex items-center mt-2">
                        <span className="mr-2">Mobile </span>
                        {data[selectedMarker].user_mobile}
                      </p>
                      <p className="font-medium text-left text-slate-700 flex items-center mt-2">
                        <span className="mr-2">Date/Time </span>
                        {data[selectedMarker].last_mobile_location_updated_time}
                      </p>
                      <p className="font-medium text-left text-slate-700 flex items-center mt-2">
                        <span className="mr-2">Last Lat - </span>
                        {data[selectedMarker].latitude}
                      </p>
                      <p className="font-medium text-slate-700 flex items-center mt-2">
                        <span className="mr-2">Last Long - </span>
                        {data[selectedMarker].longitude}
                      </p>
                      <p className="mt-2">
                        <b>Google Maps Link:</b>{" "}
                        <a
                          target="_blank"
                          href={`https://maps.google.com/?q=${data[selectedMarker].latitude},${data[selectedMarker].longitude}`}
                          style={{ cursor: "pointer", color: "blue" }}
                        >
                          https://maps.google.com/?q={data[selectedMarker].latitude},{data[selectedMarker].longitude}
                        </a>
                      </p> */}
                    
                  </div>
                </InfoWindow>
               
              </>
            )}
          </div>
        </GoogleMap>
      )}
    </>
  );
};

export default GoogleMapApi;